;(function(window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Controller = APP.module('Controller');
	var Router = APP.module('Router');
	var Model = APP.module('Model');
	var View = APP.module('View');
	var Layout = APP.module('Layout');
	var Collection = APP.module('Collection');

	Controller.TippingAflClubsNoGauntletNoPickFive = function() {

	};

	_.extend(
		Controller.TippingAflClubsNoGauntletNoPickFive.prototype,
		Controller.TippingClubs.prototype, {

			getWidgets: function() {
				return new Layout.Sidebar({
					widgets_list:    ['Promo', 'AflClubsLadder'],
					widgets_options: {
						rounds:           this.rounds,
						squads:           this.squads,
						collection:       new Collection.TippingRoundStats(),
						ladderCollection: new Collection.TippingLadder()
					}
				});
			},

			gauntlet: function() {
				return this;
			}
		});

	APP.on('start', function() {
		new Router.Tipping({controller: new Controller.TippingAflClubsNoGauntletNoPickFive()});
	});

}(window, APP, Backbone, Marionette, $, _));